import React from "react";
import { Text, Flex, Box, chakra } from "@chakra-ui/react";
import { BsTwitter } from "react-icons/bs";
import { FaTelegramPlane, FaEnvelope, FaRedditAlien } from "react-icons/fa";

// Constants
import {
  REDDIT_URL,
  SUBSCRIBE_URL,
  TELEGRAM_URL,
  TWITTER_URL,
} from "constants/constants";
import { CLICK_COMMUNITY_LINK } from "constants/analytics";
import useApp from "hooks/useApp";

const BoxWithStyle = chakra(Box, {
  baseStyle: {
    transition: "all 0.15s ease-in-out",
    _hover: {
      color: "brand.primary",
      transform: "scale(1.5)",
    },
    _dark: {
      color: "#B5B5B5",
      _hover: {
        color: "white",
      },
    },
  },
});

interface IIconLinkProps {
  children: React.ReactNode;
  href: string;
  platform: string;
}

const IconLink = ({ children, href, platform }: IIconLinkProps) => {
  const { track } = useApp();

  return (
    <BoxWithStyle
      target="_blank"
      rel="noreferrer"
      as="a"
      href={href}
      onClick={() => track(CLICK_COMMUNITY_LINK, { joc_type: platform })}
    >
      {children}
    </BoxWithStyle>
  );
};

const Socials = () => {
  return (
    <Flex
      flexDir="column"
      gap="1rem"
      justifyContent={{ base: "flex-start", xl: "space-between" }}
      alignItems={{ base: "flex-start", xl: "center" }}
      bg={{ base: "inherit", xl: "brand.backgroundLight" }}
      p={{ base: "0", xl: "1rem" }}
      pb={{ base: "0.5rem", xl: "1rem" }}
      borderRadius="1rem 1rem 0 0"
    >
      <Text textAlign={{ base: "left", xl: "center" }} fontSize="14px">
        Join our Community
      </Text>
      <Flex align="center" fontSize="1rem" gap="1rem">
        <IconLink href={TWITTER_URL} platform="twitter">
          <BsTwitter />
        </IconLink>
        <IconLink href={TELEGRAM_URL} platform="telegram">
          <FaTelegramPlane />
        </IconLink>
        <IconLink href={SUBSCRIBE_URL} platform="mail">
          <FaEnvelope />
        </IconLink>
        <IconLink href={REDDIT_URL} platform="reddit">
          <FaRedditAlien />
        </IconLink>
      </Flex>
    </Flex>
  );
};

export default Socials;
